import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import capitalize from 'scaleflow/utils/capitalize';

export default class PlanningDashboardOverviewTableController extends Controller {
  @service router;
  @service favorite;
  @service store;
  @service('beta-toggle') betaService;
  @service('organisation') orgService;
  @service intl;
  @service initiativeSlideover;
  @service betaToggle;
  @service roadmap;

  @tracked persons = [];
  @tracked initiativeFormIsVisible = false;
  @tracked showFilterSlideover = false;
  @service tracker;

  datepickerInstances = {};
  observer = null;

  queryParams = [
    'grouping',
    'statuses',
    'themes',
    'sources',
    'productManagers',
    'teams',
    'columns',
  ];

  // @tracked sort = '';
  @tracked view = '';
  @tracked grouping = null;
  @tracked statuses = [];
  @tracked themes = [];
  @tracked sources = [];
  @tracked product_managers = [];
  @tracked teams = [];
  @tracked columns = [];

  @tracked tableSort = '';
  @tracked list = [];

  @action
  onGroupingSelect(e) {
    this.grouping = e.value;
  }

  @action
  onStatusSelect(e) {
    this.status = e;
  }

  @action
  onThemeSelect(e) {
    this.themes = e;
  }

  @action
  onSourceSelect(e) {
    this.sources = e;
  }

  @action
  onPmSelect(e) {
    this.productManagers = e;
  }

  @action
  onTeamSelect(e) {
    this.teams = e;
  }

  get roadmap_id() {
    return this.roadmap?.selected?.id;
  }

  @action
  handleFilterDelete(filter) {
    const param = filter.key;
    const filters = this[param];
    if (Array.isArray(filters))
      this[param] = filters.filter((item) => item !== filter.value);
    else this[param] = null;
  }

  get columnOptions() {
    const columns = [
      // { label: this.intl.t('initiatives.table.title'), class: '!px-4 !py-3 min-w-[320px] w-full', sortKey: 'title' },
      { label: this.intl.t('_initiatives.starting-week') },
      { label: this.intl.t('_initiatives.duration') },
      { label: this.intl.t('_initiatives.progress') },
      { label: this.intl.t('_initiatives.product-manager') },
      {
        label: this.intl.t('_initiatives.teams', {
          num: 3,
        }),
      },
      {
        label: this.intl.t('roadmap.title', {
          num: 3,
        }),
        class: '!px-4 !py-3 min-w-[120px]',
      },
      { label: this.intl.t('_initiatives.status') },
      {
        label: this.intl.t('_initiatives.source', {
          num: 1,
        }),
        sortKey: 'source',
      },
      {
        label: this.intl.t('_initiatives.themes', {
          num: 3,
        }),
      },
      {
        label: capitalize(
          this.intl.t('_initiatives.goals', {
            num: 3,
          }),
        ),
        class:
          '!px-4 !py-3 min-w-[120px] max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap',
      },
      {
        label: this.intl.t('_initiatives.impact'),
        class:
          '!px-4 !py-3 min-w-[120px] max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap text-right',
        sortKey: 'bon_value',
      },
      {
        label: this.intl.t('_initiatives.investment', {
          num: 1,
        }),
        class: '!px-4 !py-3 min-w-[120px] text-right',
        sortKey: 'bon_investment',
      },
      {
        label: this.intl.t('_initiatives.returns', {
          num: 1,
        }),
        class: '!px-4 !py-3 min-w-[120px] max-w-[200px] text-right',
        sortKey: 'bon_returns',
      },
      {
        label: this.intl.t('_initiatives.effort'),
        class:
          '!px-4 !py-3 min-w-[120px] max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap text-right',
        sortKey: 'person_weeks',
      },
      {
        label: this.intl.t('_initiatives.uncertainty', { num: 1 }),
        class:
          '!px-4 !py-3 min-w-[120px] max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap text-right',
        sortKey: 'person_weeks_only_uncertainty',
      },
      {
        label: `${this.intl.t('_initiatives.effort')} ${this.intl.t('_initiatives.details')}`,
        show: false,
      },
    ];
    columns.forEach((item) => {
      item.show = this.showColumn(item);
    });
    return columns.slice();
  }

  showColumn(column) {
    if (this.columns.length === 0) {
      if (column.show !== undefined) return column.show;
      return true;
    } else {
      return this.columns.includes(column.label);
    }
  }

  @action
  toggleInitiativeForm(val) {
    if (val !== undefined) this.initiativeFormIsVisible = val;
    else this.initiativeFormIsVisible = !this.initiativeFormIsVisible;
  }

  @action
  setRoadmapOnInitiative(initiative) {
    const roadmap = this.store.peekRecord('roadmap', this.roadmap_id);
    initiative.roadmaps = [roadmap];
    initiative.save();
  }
}
